// Generated from the TokenTax Icons Figma Final page. Do not edit.
import * as React from 'react';
import type { IconProps } from './types';
import { Ref, forwardRef } from 'react';
const Search = ({ size, ...props }: IconProps, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size ?? 18}
    height={size ?? 18}
    fill="none"
    viewBox="0 0 18 18"
    ref={ref}
    {...props}
  >
    <circle cx={4.5} cy={4.5} r={4} stroke="currentColor" transform="matrix(-1 0 0 1 12 3)" />
    <path stroke="currentColor" d="M10.5 10.5 15 15" />
  </svg>
);
const ForwardRef = forwardRef(Search);
export default ForwardRef;
